module.exports = __webpack_public_path__ + "img/sealBox1.8c3adf01.png";